define('core/dfn',["exports", "core/utils"], function (exports, _utils) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.name = undefined;
  exports.run = run;
  const name = exports.name = "core/dfn"; // Module core/dfn
  // - Finds all <dfn> elements and populates conf.definitionMap to identify them.

  function run(conf) {
    document.querySelectorAll("dfn").forEach(dfn => {
      const closestDfn = dfn.closest("[data-dfn-for]");
      if (closestDfn && closestDfn !== dfn && !dfn.dataset.dfnFor) {
        dfn.dataset.dfnFor = closestDfn.dataset.dfnFor;
      }
      if (dfn.dataset.dfnFor) {
        dfn.dataset.dfnFor = dfn.dataset.dfnFor.toLowerCase();
      }
      // TODO: un-jquery stored $dfn
      // TODO: we should probably use weakmaps and weaksets here to avoid leaks.
      const $dfn = $(dfn);
      (0, _utils.getDfnTitles)(dfn, { isDefinition: true }).map(dfnTitle => {
        if (!conf.definitionMap[dfnTitle]) {
          conf.definitionMap[dfnTitle] = [];
        }
        return conf.definitionMap[dfnTitle];
      }).reduce(($dfn, dfnTitleContainer) => {
        dfnTitleContainer.push($dfn);
        return $dfn;
      }, $dfn);
    });
  }
});
//# sourceMappingURL=dfn.js.map;
